import { Navigate, useLocation } from "react-router-dom";
import { useUserStore } from "../../modules/user/stores";
import { ROUTES } from "../../types/routes";
import utils from "../../utils";

interface ProtectedRouteProps {
  children: React.ReactElement;
}

/**
 * 如果用户未登录，则重定向到登录页面
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = useUserStore(state => state.isAuthenticated());

  if (!isAuthenticated) {
    const hasRegistered = utils.getObject("has_registered");
    const redirectTo = hasRegistered ? ROUTES.LOGIN : ROUTES.REGISTER;
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
